export default __webpack_public_path__ + "fonts/Rubik-VariableFont_wght.ttf";